/** Human-readable, quote-local review notes survive draft/quote persistence
 * without representing unpriced work as a zero-priced, included line item. */
export interface ScopeReviewIssue {
  missingWork: string;
  sourceQuote: string;
  resolved: boolean;
  resolution?: string;
}
const oneLine = (value: string) => value.replace(/\s+/g, " ").trim();
export function scopeReviewNote(issue: ScopeReviewIssue): string {
  return `[Scope review: ${issue.resolved ? "resolved" : "needs attention"}]\nWork: ${oneLine(issue.missingWork)}\nSource: ${oneLine(issue.sourceQuote)}` +
    (issue.resolution ? `\nResolution: ${oneLine(issue.resolution)}` : "");
}
export function parseScopeReviewNote(note: string): ScopeReviewIssue | null {
  const match = note.match(/^\[Scope review: (needs attention|resolved)\]\nWork: ([^\n]+)\nSource: ([^\n]*)(?:\nResolution: ([^\n]+))?$/);
  return match ? { missingWork: match[2], sourceQuote: match[3], resolved: match[1] === "resolved",
    ...(match[4] ? { resolution: match[4] } : {}) } : null;
}
export function updateScopeReviewNote(notes: string[], note: string, resolved: boolean, resolution?: string): string[] {
  const issue = parseScopeReviewNote(note);
  return issue ? notes.map(current => current === note ? scopeReviewNote({ ...issue, resolved, resolution }) : current) : notes;
}
